import {kebabCase} from 'lodash'
import enquire from 'enquire.js'
import Flickity from 'flickity-imagesloaded'
import ScrollReveal from 'scrollreveal'
import videojs from 'video.js'
import * as modal from './modal'

const jQueryBridget = require('jquery-bridget')

// make Flickity a jQuery plugin
jQueryBridget('flickity', Flickity, $)

const DESKTOP_BREAKPOINT = '58em'

const EVENTS = {
  FLICKITY_CLICK: 'staticClick.flickity',
}

const SELECTORS = {
  SLIDER: '[data-product-slider]',
  SLIDE: '[data-product-slide-id]',
  SLIDE_DOTS: '.flickity-page-dots',
  PRODUCT_IMAGE: '.product__photo',
}

const SLIDE_CLASS = 'product-slide'
const SLIDE_IS_VISIBLE_CLASS = 'product-slider--is-visible'

let origOffsetY = getOffsetY()

const $slide = $(SELECTORS.SLIDE)
const $html = $('html')

let slider
const sliderOptions = {
  cellAlign: 'center',
  imagesLoaded: true,
  pageDots: true,
  percentPosition: true,
  prevNextButtons: false,
}

let scrollReveal = ScrollReveal()

if (scrollReveal.isSupported()) {
  $html.addClass('scrollreveal')
} else {
  $html.addClass('no-scrollreveal')
}

const scrollRevealOpts = {
  delay: 110,
  duration: 220,
  distance: '1rem',
  easing: 'cubic-bezier(0.455, 0.030, 0.515, 0.955)',
  opacity: 0,
  scale: 1,
}

export function productSlider() {
  modal.init()

  enquire.register(`screen and (min-width: ${DESKTOP_BREAKPOINT})`, {
    match: () => {
      scrollReveal.reveal(SELECTORS.SLIDE, scrollRevealOpts)

      if ($('#ProductVideoAutoplay').length) {
        videojs('ProductVideoAutoplay').ready(function() {
          this.play()
          this.on('fullscreenchange', () => $html.toggleClass('vjs-fullscreen'))
        })

      }
    },
  }, true)

  enquire.register(`screen and (max-width: ${DESKTOP_BREAKPOINT})`, {
    match: () => {
      slider = $(SELECTORS.SLIDER).flickity(sliderOptions)
    }
  })

  if (slider) {
    slider.on(EVENTS.FLICKITY_CLICK, (event, pointer, cellElement) => {
      if (!cellElement) {
        return
      }

      const id = $(cellElement).attr('data-open-modal-id')
      modal.open(id)
    })

    if ($(SELECTORS.SLIDE_DOTS).children().length === 1) {
      $(SELECTORS.SLIDE_DOTS).hide()
    }
  } else {
    $slide.on('click', (event) => {
      const id = $(event.currentTarget).attr('data-open-modal-id')
      modal.open(id)
    })
  }
}

export function stickyContent() {
  stickyContentHandler(origOffsetY)
  $(document).on('scroll', stickyContentHandler)
}

function handleize(text) {
  return kebabCase(text).toLowerCase()
}

function getOffsetY() {
  return Math.floor($('.product').height() - ($(window).height() / 2) - 60)
}

function stickyContentHandler() {
  const $stickyEls = $('.product-header, .product-purchase-wrap')
  const STICKY_HIDDEN_CLASS = 'is-hidden'

  origOffsetY = getOffsetY()

  if (window.scrollY >= origOffsetY) {
   $stickyEls.addClass(STICKY_HIDDEN_CLASS)
  } else {
    $stickyEls.removeClass(STICKY_HIDDEN_CLASS)
  }
}



// WEBPACK FOOTER //
// ./product-detail.js